export const DOCUMENT_FILE_TYPES = {
  '1': 'JPEG',
  '2': 'PNG',
  '3': 'PDF',
}